/**
 * The `steps[]` convention for every calculator: an ordered list of the working behind a result.
 * The API returns the same shape in its `steps` field (utility-api/core/converters/amortization.ts is the first user).
 *
 * A calculator builds its steps from the SAME numbers it shows as the result, never from a second calculation,
 * so the working can never disagree with the answer.
 */
export interface CalcStep {
  /** Short name of the step, e.g. "Monthly payment". */
  label: string;
  /** The rule in words, e.g. "Loan amount x rate / (1 - (1 + rate) ^ -payments)". */
  formula: string;
  /** The values used, by display name. Already formatted for people (or plain numbers for the API). */
  inputs: Record<string, number | string>;
  /** The outcome of this step, already formatted. */
  result: number | string;
}

/** Plain text of the working, for copy and print. One block per step. */
export function stepsToText(steps: CalcStep[]): string {
  return steps
    .map((s, i) => {
      const inputs = Object.entries(s.inputs).map(([k, v]) => `${k} = ${v}`).join("; ");
      return `${i + 1}. ${s.label}\n   ${s.formula}\n   ${inputs ? `Using ${inputs}\n   ` : ""}Result: ${s.result}`;
    })
    .join("\n");
}
